var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "keepMaterialAdmin" },
    [
      _c(
        "van-pull-refresh",
        {
          attrs: { "success-text": "刷新成功" },
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing"
          }
        },
        [
          _vm.ishow
            ? [
                _c("van-empty", {
                  staticClass: "custom-image",
                  attrs: {
                    image: require("@/assets/images/pic_no information@2x.png"),
                    description: "暂无数据!"
                  }
                })
              ]
            : _vm._e(),
          !_vm.ishow
            ? _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了"
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading"
                  }
                },
                _vm._l(_vm.list, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.openId,
                      staticClass: "data",
                      on: {
                        click: function($event) {
                          return _vm.toMaterialManage(item)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "startTime" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatTime")(
                              _vm._f("formatDate_")(item.created)
                            )
                          )
                        )
                      ]),
                      _c("div", { staticClass: "weight" }, [
                        _vm._v(_vm._s(item.weight.toFixed(2)) + "g")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "realTlmeMOney",
                          style: {
                            color: item.overPercent ? "#dc001a" : "#1a1a1a"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              item.mortgageStatus == "CLOSE"
                                ? "--"
                                : item.mortgageStatus == "WAIT_CONFIRM"
                                ? "--"
                                : item.realTimeMoney.toFixed(2) + "元"
                            )
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "state",
                          style: {
                            color:
                              item.mortgageStatus == "MATERIAL"
                                ? "#F52621"
                                : item.mortgageStatus == "CLOSE"
                                ? "#00AD8C"
                                : "#FF7A00"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              item.mortgageStatus == "CLOSE"
                                ? "已结算"
                                : item.mortgageStatus == "MATERIAL"
                                ? "提料中"
                                : "申请中"
                            )
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }